module.exports = __webpack_public_path__ + "static/img/sharp.90b0b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sharp.jpg
// module id = uQbr
// module chunks = 0